import Vue from 'vue';
import VuePannellum from 'vue-pannellum';

Vue.component('VPannellum', VuePannellum);
